// extracted by mini-css-extract-plugin
module.exports = {"list":"_1fO_EYlx","circle":"_3XOOh6id","middleCircle":"_39hz5bp4","ls":"v1zRpqxd","button":"_1YGIUge8","disable":"_3FzVbXv5"};